module.exports = __webpack_public_path__ + "img/Marguerite Harper Scott (1).9fe637b0.png";